import { Button, Typography } from '@breetometer/components';
import { CopyIcon, NotificationBannerAlertIcon } from 'BreetAssets';
import { copyToClipboard } from 'BreetHelpers';
import { selectModals, useAppSelector } from 'BreetRedux';

const DialogWebhookVerification = () => {
	const modals = useAppSelector(selectModals);

	const modal = modals.find((modalItem) => modalItem.id === 'webhookVerification');

	const metadata = modal?.metadata as { secretkey: string; keyType: 'api' | 'webhook' } | undefined;

	return (
		<div className='dialog-webhook-verification bg-primary-500'>
			<Typography
				as='h1'
				className='color-neutral-50'
			>
				{metadata?.keyType === 'api' ? 'API Secret Key' : 'Webhook Verification Secret Key'}
			</Typography>

			<div className='dialog-webhook-verification_note'>
				<NotificationBannerAlertIcon
					status='warning'
					className='status-icon-pending'
				/>
				{metadata?.keyType === 'api' ? (
					<Typography>This key appears once. Save it now, you won&apos;t see it again.</Typography>
				) : (
					<Typography>This key will be used to verify webhook requests.</Typography>
				)}
			</div>

			<div className='dialog-webhook-verification_secretkey bg-primary-400 border-dark-navy'>
				<Typography className='color-primary-50'>{metadata?.secretkey}</Typography>

				<div className='dialog-webhook-verification_copy'>
					<Button
						leadingIcon={<CopyIcon variant='colored' />}
						variant='native'
						onClick={copyToClipboard(metadata?.secretkey, 'Secret key copied ')}
						className='color-tertiary-400'
					>
						Copy
					</Button>
				</div>
			</div>
		</div>
	);
};

export default DialogWebhookVerification;
